import { render } from "./MyCourse.vue?vue&type=template&id=f8462bf8"
import script from "./MyCourse.vue?vue&type=script&lang=js"
export * from "./MyCourse.vue?vue&type=script&lang=js"

import "./MyCourse.vue?vue&type=style&index=0&id=f8462bf8&lang=scss"
script.render = render

export default script